import { render, staticRenderFns } from "./printComp.vue?vue&type=template&id=24d83b8a&scoped=true&"
import script from "./printComp.vue?vue&type=script&lang=js&"
export * from "./printComp.vue?vue&type=script&lang=js&"
import style0 from "./printComp.vue?vue&type=style&index=0&id=24d83b8a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d83b8a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\mzkj\\要炼\\yl-pc-business\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24d83b8a')) {
      api.createRecord('24d83b8a', component.options)
    } else {
      api.reload('24d83b8a', component.options)
    }
    module.hot.accept("./printComp.vue?vue&type=template&id=24d83b8a&scoped=true&", function () {
      api.rerender('24d83b8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pint-comp/printComp.vue"
export default component.exports